import { Component } from '@angular/core';
@Component({
    selector: 'app-engagements',
    templateUrl: './engagements.component.html',
    styleUrls: ['./engagements.component.scss'],
    standalone: false
})
export class EngagementsComponent {}
